@if(isOpen){
<div class="overlay">
    &nbsp;
</div>
<div class="text-update-box-wrapper center-full">
    <ngb-toast [header]="header" [autohide]="false" (hidden)="onAction(1)">
        <div class="row">
            <div class="col-12">
                <div style="font-size: large;max-height: calc(100vh - 200px);overflow-x: hidden;">
                    <textarea *ngIf="!isReadOnly" id="{{elementIds.txt_update}}" rows="5" [(ngModel)]="value"
                        title="{{placeHolder}}" placeholder="{{placeHolder}}"></textarea>
                    <div *ngIf="isReadOnly">
                        {{value ?? placeHolder}}
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="!isReadOnly">
            <div class="col-6">
            </div>
            <div class="col-6" style="text-align: right;">
                <button type="button" class="btn btn-primary"
                    (click)="onAction(2)">{{localService.languageContent.common.save}}</button>
            </div>
        </div>
    </ngb-toast>
</div>
}